import AboutPrepayContainer from './AboutPrepayContainer';

export default AboutPrepayContainer;
